import React from 'react';

import Checkbox from '@mui/material/Checkbox';
import SvgIcon from '@mui/material/SvgIcon';
import Tooltip from '@mui/material/Tooltip';
import LanguageIcon from '@mui/icons-material/Language';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

import {checkboxStateEnum, accessItemTypeEnum} from '../../../serverClientShared/sharedEnums';

const GROUP_CHECKED = 'group_checked';
const GROUP_INDETERMINATE = 'group_indeterminate';

const OUTLINE_PATH = 'M19 5v14H5V5zm0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2';
const CHECK_PATH = 'M10 17l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8z';
const DASH_PATH = 'M17 13H7v-2h10z';

const GroupCheckedIcon = (props) => (
    <SvgIcon {...props}>
        <path d={OUTLINE_PATH} fill="var(--main-disabled-color)" />
        <path d={CHECK_PATH} fill="var(--classicbutton-normal-color)" />
    </SvgIcon>
);

const GroupIndeterminateIcon = (props) => (
    <SvgIcon {...props}>
        <path d={OUTLINE_PATH} fill="var(--main-disabled-color)" />
        <path d={DASH_PATH} fill="var(--classicbutton-normal-color)" />
    </SvgIcon>
);

const GROUP_SX = {
    color: 'var(--main-disabled-color)',
};

const GroupCheckbox = ({testId, isChecked, onToggle}) => (
    <Checkbox
        data-testid={testId}
        size="small"
        checked={isChecked}
        indeterminate={!isChecked}
        onChange={onToggle}
        style={{padding: 2, marginRight: 4, cursor: onToggle ? 'pointer' : 'default'}}
        sx={GROUP_SX}
        checkedIcon={<GroupCheckedIcon />}
        indeterminateIcon={<GroupIndeterminateIcon />}
    />
);

export const AccessCheckbox = ({state, onToggle, disabled, 'data-testid': testId}) => {
    if (state === GROUP_CHECKED || state === GROUP_INDETERMINATE) {
        return <GroupCheckbox testId={testId} isChecked={state === GROUP_CHECKED} onToggle={onToggle} />;
    }
    return (
        <Checkbox
            data-testid={testId}
            size="small"
            checked={!disabled && (state === checkboxStateEnum.CHECKED || state === checkboxStateEnum.INCLUDE_ALL)}
            indeterminate={!disabled && state === checkboxStateEnum.INDETERMINATE}
            onChange={disabled ? undefined : onToggle}
            disabled={disabled}
            style={{padding: 2, marginRight: 4}}
        />
    );
};

export {GROUP_CHECKED, GROUP_INDETERMINATE};

const TOOLTIP_PROPS = {
    tooltip: {
        className: '!text-base !text-main-normal !bg-background-normal !border !border-panels-normal !shadow-lg !rounded-input',
    },
};

const specialBadgeEnum = {
    PUBLIC: 'PUBLIC',
    SHARED: 'SHARED',
};

const getSpecialTooltip = (label, nodeType) => {
    if (label === specialBadgeEnum.PUBLIC) return 'Available to everyone';
    if (label === specialBadgeEnum.SHARED) {
        if (nodeType === accessItemTypeEnum.PROJECT) return 'Accessible to all workspace members';
        return 'Accessible to all members with access to the parent';
    }
    return label;
};

export const SpecialBadge = ({label, nodeType}) => (
    <Tooltip
        title={getSpecialTooltip(label, nodeType)}
        placement="top"
        enterDelay={300}
        componentsProps={TOOLTIP_PROPS}
    >
        <span
            className="inline-flex items-center gap-1 px-2 py-0.5 rounded-menu text-xs font-medium text-classic-button-normal cursor-default"
            style={{backgroundColor: 'color-mix(in srgb, var(--classic-button-normal-color) 10%, transparent)'}}
        >
            <LanguageIcon style={{fontSize: 12}} />
            {label}
        </span>
    </Tooltip>
);

export const DirectBadge = () => (
    <Tooltip
        title="Assigned to this user individually, not through a group"
        placement="top"
        enterDelay={300}
        componentsProps={TOOLTIP_PROPS}
    >
        <span
            className="inline-flex items-center gap-1 px-2 py-0.5 rounded-menu text-xs font-medium text-main-normal cursor-default"
            style={{backgroundColor: 'rgba(0, 0, 0, 0.06)'}}
        >
            <InfoOutlinedIcon style={{fontSize: 12}} />
            Direct +
        </span>
    </Tooltip>
);
